import { useState , useEffect, useCallback, useContext } from "react";

import { Box, Typography, Button } from "@mui/material";
import { Add, Diversity3, QrCode, QrCodeScanner, FastForward } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import GenerateQRCode from "../../components/DashboardPlus/GenerateQRCode";

import { callPostApi } from "../../function/ApiCallFunction";
import GradientLoader from "../../components/CommanComponents/GradientLoader";
import { DataContext } from "../../context/DataContext";
import { consoleColors, primaryButtonSx } from "../admin/consoleTheme";
import SaleLinkBox from "../report/SaleLinkBox";
import { ClubMembers } from "./Home";

function DashboardPlus() 
{
    const navigate = useNavigate();
    
    const [loading, setLoading] = useState(false);
    const [open,    setOpen]    = useState(false);
    const [datar,   setDatar]   = useState({ total_pending: 0, total_loaded: 0, total_active: 0, total_customer: 0, club: null, club_members: [] });
  
    const {loginData }  = useContext(DataContext);
    const store_id      = loginData?.store_info?.store_id;


    //  const cashi_plus_flag = "1";
    const dashboardApi = useCallback(async () =>
    {
        setLoading(true);
        try 
        {
            const payload = { mod: "CASHI_PLUS_DASHBOARD", data_arr: { store_id},};
            const apiResult = await callPostApi("cashi-dashboard", payload);

            if (apiResult.status === "200" && apiResult.data) 
            {
                const item = apiResult.data;
                setDatar({
                      total_pending: item.total_pending || 0,
                      total_loaded: item.total_loaded || 0,
                      total_active: item.total_active || 0,
                      total_customer: item.total_customer || 0,
                      club: item.club || null,
                      club_members: item.club_members || [],
                });
            }

        }
        catch (err) { console.error("Dashboard API failed", err); } 
        finally { setLoading(false); }

    }, [store_id]);

    useEffect(() => { dashboardApi(); }, [dashboardApi]);
     

    const cards = [
        { key: "pending", label: "Generated QR coupons", value: datar.total_pending, to: "generatedQR", icon: QrCode, tint: "#e4f4fd", color: "#21a7ec" },
        { key: "loaded", label: "Loaded QR coupons", value: datar.total_loaded, to: "loadedQR", icon: FastForward, tint: "#e0e7ff", color: "#4338ca" },
        { key: "active", label: "Activated QR coupons", value: datar.total_active, to: "activatedQR", icon: QrCodeScanner, tint: "#dcfce7", color: "#15803d" },
        { key: "customers", label: "Customers", value: datar.total_customer, to: "totalPlusCustomer", icon: Diversity3, tint: "#cffafe", color: "#0e7490" },
    ];

  return (
    <Box sx={{ p: { xs: 2, md: 3 } }}>
      <SaleLinkBox storeId={store_id} />
      <ClubMembers club={datar.club} members={datar.club_members} />
      <Box sx={{ mb: 2 }}>
        <Button variant="contained" sx={primaryButtonSx} onClick={() => setOpen(true)}><Add sx={{ mr: 0.5 }} /> Generate QR coupons</Button>
        <GenerateQRCode open={open} onClose={() => setOpen(false)} />
      </Box>
      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", lg: "repeat(4, 1fr)" }, gap: 1.5 }}>
        {cards.map((card) => {
          const Icon = card.icon;
          return (
            <Box
              key={card.key}
              onClick={() => navigate(card.to)}
              sx={{
                background: "#fff",
                border: `1px solid ${consoleColors.line}`,
                borderRadius: 2.5,
                p: 2,
                cursor: "pointer",
                display: "flex",
                gap: 1.5,
                alignItems: "center",
                "&:hover": { borderColor: "#cbd5e1", boxShadow: "0 8px 20px rgba(15,23,42,0.06)" },
              }}
            >
              <Box sx={{ width: 42, height: 42, borderRadius: 2, background: card.tint, color: card.color, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <Icon sx={{ fontSize: 22 }} />
              </Box>
              <Box>
                <Typography sx={{ fontSize: 24, fontWeight: 700, color: consoleColors.ink, lineHeight: 1 }}>{card.value}</Typography>
                <Typography sx={{ fontSize: 13, color: consoleColors.muted, mt: 0.4 }}>{card.label}</Typography>
              </Box>
            </Box>
          );
        })}
      </Box>
      {loading && <GradientLoader text="Loading" />}
    </Box>
  );
}


export default DashboardPlus;
